import { Component, OnInit } from '@angular/core';
import { Router, NavigationStart } from '@angular/router';
import { WalletSummaryService } from 'src/app/shared/services/api/wallet-summary.service';
import { WalletSummary } from 'src/app/shared/models/wallet-summary.interface';
import { SessionService } from 'src/app/shared/services/session.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { filter } from 'rxjs';

@Component({
  selector: 'app-contact-us',
  templateUrl: './contact-us.component.html',
  styleUrls: ['./contact-us.component.scss']
})
export class ContactUsComponent implements OnInit{

  insureShieldShippingInsurance: SafeHtml;
  dataLoaded = false;
  isBilliant: boolean = false;

  // Sidebar settings
  myAccountActive: boolean = false;
  contactUsActive: boolean = false;
  preferencesActive: boolean = false;
  managePaymentActive: boolean = false;
  autoRedeemActive: boolean = false;
  autoPayActive: boolean = false;

  walletSummary: WalletSummary | null = null;
  cashEligible = false;
  rewardEligible = false;

  isPPI: boolean = false; 

  constructor(
    private router: Router,
    private walletSummaryService: WalletSummaryService,
    private sanitizer: DomSanitizer, 
    private translate: TranslateService,
    private sessionService: SessionService
  ) {
    this.setActiveLinks(this.router.url);
    this.router.events.pipe(filter((event: any) => event instanceof NavigationStart)).subscribe(
    (event: NavigationStart) => {
      this.setActiveLinks(event.url);
    }
  );

    this.translate.get('contactUs.insureShieldShippingInsurance').subscribe((res: string) => {
      this.insureShieldShippingInsurance = res;
    });
  }

  // Add this method inside the ContactUsComponent class
private setActiveLinks(url: string): void {
  this.myAccountActive = url.startsWith('/my-account');
  this.contactUsActive = url.startsWith('/contact-us');
  this.preferencesActive = url.startsWith('/preferences');

  // Reset all preferences sub-items
  this.managePaymentActive = false;
  this.autoRedeemActive = false;
  this.autoPayActive = false;

  if (this.preferencesActive) {
    if (url.startsWith('/preferences/manage-payment')) {
      this.managePaymentActive = true;
    } else if (url.startsWith('/preferences/auto-redeem')) {
      this.autoRedeemActive = true;
    } else if (url.startsWith('/preferences/auto-pay')) { 
      this.autoPayActive = true;
    }
  }
}

  ngOnInit() {

    /* this.sessionService.isBilliant$.subscribe(val => {
      this.isBilliant = val;
    }); */
    this.isBilliant=sessionStorage.getItem("isBilliant")!=null?sessionStorage.getItem("isBilliant").toLocaleLowerCase()=="true"?true:false:false;
    
    this.walletSummaryService.walletSummary$.subscribe(summary => {

      if (!summary || (!summary.wallet && !summary.ppi?.wallet)) {
      return; // Ignore empty or intermediate emissions
    }
      this.walletSummary = summary;
      this.cashEligible = summary?.wallet?.cashEligible === "True";
      this.rewardEligible = summary?.wallet?.rewardEligible === "True";

     const ppiWallet = summary?.ppi?.wallet;
    const hasValidPPIWallet =
      ppiWallet &&
      ppiWallet.walletID !== null &&
      ppiWallet.walletID !== undefined &&
      ppiWallet.walletID.trim() !== "";

    this.isPPI = hasValidPPIWallet;
      this.dataLoaded = true;
      this.setActiveLinks(this.router.url);
    })
  }
}
